
const GOOGLE_CLIENT_ID = process.env.VUE_APP_GOOGLE_CLIENT_ID

const URL_WEB = 'http://doit.lic.vnu.edu.vn'
const INTERVAL_RELOAD_DATA = 15 * 1000 //miniseconds

const TEMP_TOKEN_EXPIRE_TIME = 15 * 60 * 1000 // miniseconds
const TEMP_TOKEN_MAX_AGE = 604800

export {
    // URL_API_HOST,
    URL_WEB,
    INTERVAL_RELOAD_DATA,
    GOOGLE_CLIENT_ID,
    TEMP_TOKEN_EXPIRE_TIME,
    TEMP_TOKEN_MAX_AGE
    // getUrlApiMappingUsername,
}
